import { is } from '../is.js';
import { FULLSCREEN, STANDARD } from '../constants.js';

export function resolveDisplayMode(schema) {
  schema.slides.forEach((slide) => {
    const hasContainer = slide.widgets.some(is.widget.containerType);
    slide._displayMode = hasContainer ? STANDARD : FULLSCREEN;
  });

  return schema;
}
